import {
    withStyles,
  } from "@material-ui/core/styles";
  import Button from "@material-ui/core/Button";
  import Colors from "./colors"
  
  const DarkButton = withStyles((theme) => ({
    root: {
      backgroundColor: Colors.globalColor8,
      "&:hover": {
        backgroundColor: Colors.globalColor8,
      },
    },
    label: {
      color: "#ffffff",
      textTransform:'uppercase',
      margin:"0px 10px",
      fontFamily: 'Poppins',
      width:'100%',
      color:"white",
      padding:"3px 10px",
      fontSize: "10px",
    },
  }))(Button);
  
  export default DarkButton
  